/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auto_Format_CustomInputs */



/**
* | output |
* | --- |
* | "Auto Format Custom..." |
*
* @param {Auto_Format_CustomInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const auto_format_custom = /** @type {((inputs?: Auto_Format_CustomInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auto_Format_CustomInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Format auto personnalisé...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatische Formatierung Benutzerdefiniert...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Formattazione automatica personalizzata...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Автоматическое форматирование...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Formato automático personalizado...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("自动格式化自定义...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("自動フォーマットカスタム...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कस्टम फॉर्मेट को स्वचालित रूप से फॉर्मेट करें...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Formatação automática personalizada...")
	return /** @type {LocalizedString} */ ("Auto Format Custom...")
});